import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-passt-actividad-comentarios-dialog',
  templateUrl: './passt-actividad-comentarios-dialog.component.html',
  styleUrls: ['./passt-actividad-comentarios-dialog.component.css']
})
export class PasstActividadComentariosDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
